import { getCO2Aequivalent } from '../getCO2Aequivalent';
import { getEmissionsFaktor } from '../getEmmissionsFaktor';
import { getKennzahl, Kennzahl, parseKey } from '../strukturiert/Kennzahl';
import { getUmrechungsFaktor } from '../getUmrechnungsFaktor';
import { IDs } from '../../../helpers/IDs';
import { isValid as isValidKraftstoffe } from '../validData';
import { KennzahlFaktor } from '../strukturiert/KennzahlFaktor';
import { setKennzahlObj } from '../strukturiert/KennzahlTools';

export function extractEnergieKraftstoffe(data: any, base: any, standort: any) {
    const standorte = data[IDs.ENT_STANDORT];
    const kraftstoffe = data[IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE].filter((item: any) => !standort || standort.tid === item.standort_tid_orig);

    // Standorte-Map
    const veranstaltungen_enabled = ((data[IDs.ENT_KONFIGURATION] || [])[0] || {}).veranstaltungen_orig === 1;
    const standorteMap: any = {};
    standorte
        // schließen deaktivierte Veranstaltungen oder Veranstaltungen ohne Standorte aus.
        .filter((s: any) => !((s.standort_typ_tid_orig === 5 || s.standort_typ_tid_orig === 6) && (!veranstaltungen_enabled || !s.standort_tid_orig)))
        .forEach((s: any) => standorteMap[s.tid] = s.energiedaten_erfassen_orig === 1 || s.energiedaten_erfassen === 1);

    /******************** KRAFTSTOFFE ************************************************************* */
    // Monatswerte ausfiltern
    kraftstoffe
        .filter((item: any) =>
            (item.monat === undefined || item.monat <= 0)
            && isValidKraftstoffe(item, IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE)
        )
        .forEach((item: any) => {
            const standortTid = item.standort_tid_orig ? item.standort_tid_orig : item.standort_tid;
            if (!standortTid || !standorteMap[standortTid]) {
                return;
            }
            const jahr = item.jahr;
            if (!base[jahr]) {
                base[jahr] = {};
            }
            if (item.verbrauch && item.verbrauch > 0) {
                base['flags'].hasKraftstoffe = true;
            }
            const energietraeger = item.energietraeger_tid;

            // Keine Hochrechnung der Kraftstoffverbräuche
            // const factor_hochrechnung = getFactorHochrechnung(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis, item.jahr);
            const factor_hochrechnung = 1;
            const verbrauch = item.verbrauch * (factor_hochrechnung || 1);
            const kosten = item.kosten * (factor_hochrechnung || 1);

            if (energietraeger === 'Bioethanol [Liter]') {
                if (item.messsystem) {
                    if (base[jahr]['bioethanol_messsystem']) {
                        base[jahr]['bioethanol_messsystem'] += ', ' + item.messsystem;
                    } else {
                        base[jahr]['bioethanol_messsystem'] = item.messsystem;
                    }
                }
                if (item.kalibrierung) {
                    if (base[jahr]['bioethanol_kalibrierung']) {
                        base[jahr]['bioethanol_kalibrierung'] += ', ' + item.kalibrierung;
                    } else {
                        base[jahr]['bioethanol_kalibrierung'] = item.kalibrierung;
                    }
                }
                if (!base[jahr].bioethanol_datenqualitaet) {
                    base[jahr].bioethanol_datenqualitaet = [];
                }
                base[jahr].bioethanol_verbrauch = (base[jahr].bioethanol_verbrauch || 0) + verbrauch;
                base[jahr].bioethanol_kosten = (base[jahr].bioethanol_kosten || 0) + kosten;
                base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten;
                // CO2
                base[jahr].co2_fussabdruck_bioethanol_menge = (base[jahr].co2_fussabdruck_bioethanol_menge || 0) + verbrauch;
                base[jahr].co2_fussabdruck_bioethanol_einheit = 'Liter';
                base[jahr].bioethanol_datenqualitaet.push({
                    wert: +(verbrauch || 0), datenherkunft: +(item.datenherkunft || 0), bewertung: 1
                });
                // Kennzahl
                let faktor_um_quelle;
                const faktor_um = getUmrechungsFaktor(data, '', jahr, 'bioethanol', (data: any) => faktor_um_quelle = data.quelle_bioethanol);
                setKennzahlKraftstoffe(standort, data, 'bioethanol_liter', 'verbrauch', item, 'Bioethanol', 'Liter');
                setKennzahlKraftstoffe(standort, data, 'bioethanol_kwh', 'verbrauch', item, 'Bioethanol', 'kWh', 'Liter', faktor_um, faktor_um_quelle);
                setKennzahlKraftstoffe(standort, data, 'bioethanol_kosten', 'kosten', item, 'Bioethanol', '€');
                const faktor_co2 = getCO2Aequivalent(data, jahr, 'bioethanol', false);
                if (faktor_co2) {
                    setKennzahlKraftstoffe(standort, data, 'bioethanol_co2', 'verbrauch', item, 'Bioethanol', 'tCO₂Äq', 'Liter', faktor_um, faktor_um_quelle, faktor_co2.wert, faktor_co2.quelle);
                }
            } else if (energietraeger === 'Biodiesel [Liter]') {
                if (item.messsystem) {
                    if (base[jahr]['biodiesel_messsystem']) {
                        base[jahr]['biodiesel_messsystem'] += ', ' + item.messsystem;
                    } else {
                        base[jahr]['biodiesel_messsystem'] = item.messsystem;
                    }
                }
                if (item.kalibrierung) {
                    if (base[jahr]['biodiesel_kalibrierung']) {
                        base[jahr]['biodiesel_kalibrierung'] += ', ' + item.kalibrierung;
                    } else {
                        base[jahr]['biodiesel_kalibrierung'] = item.kalibrierung;
                    }
                }
                if (!base[jahr].biodiesel_datenqualitaet) {
                    base[jahr].biodiesel_datenqualitaet = [];
                }
                base[jahr].biodiesel_verbrauch = (base[jahr].biodiesel_verbrauch || 0) + verbrauch;
                base[jahr].biodiesel_kosten = (base[jahr].biodiesel_kosten || 0) + kosten;
                base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten;
                // CO2
                base[jahr].co2_fussabdruck_biodiesel_menge = (base[jahr].co2_fussabdruck_biodiesel_menge || 0) + verbrauch;
                base[jahr].co2_fussabdruck_biodiesel_einheit = 'Liter';
                base[jahr].biodiesel_datenqualitaet.push({
                    wert: +(verbrauch || 0), datenherkunft: +(item.datenherkunft || 0), bewertung: 1
                });
                // Kennzahl
                let faktor_um_quelle;
                const faktor_um = getUmrechungsFaktor(data, '', jahr, 'biodiesel', (data: any) => faktor_um_quelle = data.quelle_biodiesel);
                setKennzahlKraftstoffe(standort, data, 'biodiesel_liter', 'verbrauch', item, 'Biodiesel', 'Liter');
                setKennzahlKraftstoffe(standort, data, 'biodiesel_kwh', 'verbrauch', item, 'Biodiesel', 'kWh', 'Liter', faktor_um, faktor_um_quelle);
                setKennzahlKraftstoffe(standort, data, 'biodiesel_kosten', 'kosten', item, 'Biodiesel', '€');
                const faktor_co2 = getCO2Aequivalent(data, jahr, 'biodiesel', false);
                if (faktor_co2) {
                    setKennzahlKraftstoffe(standort, data, 'biodiesel_co2', 'verbrauch', item, 'Biodiesel', 'tCO₂Äq', 'Liter', faktor_um, faktor_um_quelle, faktor_co2.wert, faktor_co2.quelle);
                }
            } else if (energietraeger === 'Benzin [Liter]') {
                if (item.messsystem) {
                    if (base[jahr]['benzin_messsystem']) {
                        base[jahr]['benzin_messsystem'] += ', ' + item.messsystem;
                    } else {
                        base[jahr]['benzin_messsystem'] = item.messsystem;
                    }
                }
                if (item.kalibrierung) {
                    if (base[jahr]['benzin_kalibrierung']) {
                        base[jahr]['benzin_kalibrierung'] += ', ' + item.kalibrierung;
                    } else {
                        base[jahr]['benzin_kalibrierung'] = item.kalibrierung;
                    }
                }
                if (!base[jahr].benzin_datenqualitaet) {
                    base[jahr].benzin_datenqualitaet = [];
                }
                base[jahr].benzin_verbrauch = (base[jahr].benzin_verbrauch || 0) + verbrauch;
                base[jahr].benzin_kosten = (base[jahr].benzin_kosten || 0) + kosten;
                base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten;
                // CO2
                base[jahr].co2_fussabdruck_benzin_menge = (base[jahr].co2_fussabdruck_benzin_menge || 0) + verbrauch;
                base[jahr].co2_fussabdruck_benzin_einheit = 'Liter';
                base[jahr].benzin_datenqualitaet.push({
                    wert: +(verbrauch || 0), datenherkunft: +(item.datenherkunft || 0), bewertung: 1
                });
                // Kennzahl
                let faktor_um_quelle;
                const faktor_um = getUmrechungsFaktor(data, '', jahr, 'ottokraftstoffe', (data: any) => faktor_um_quelle = data.quelle_ottokraftstoffe);
                setKennzahlKraftstoffe(standort, data, 'benzin_liter', 'verbrauch', item, 'Benzin', 'Liter');
                setKennzahlKraftstoffe(standort, data, 'benzin_kwh', 'verbrauch', item, 'Benzin', 'kWh', 'Liter', faktor_um, faktor_um_quelle);
                setKennzahlKraftstoffe(standort, data, 'benzin_kosten', 'kosten', item, 'Benzin', '€');
                const faktor_co2 = getCO2Aequivalent(data, jahr, 'benzin', false);
                if (faktor_co2) {
                    setKennzahlKraftstoffe(standort, data, 'benzin_co2', 'verbrauch', item, 'Benzin', 'tCO₂Äq', 'Liter', faktor_um, faktor_um_quelle, faktor_co2.wert, faktor_co2.quelle);
                }
            } else if (energietraeger === 'Diesel [Liter]') {
                if (item.messsystem) {
                    if (base[jahr]['diesel_messsystem']) {
                        base[jahr]['diesel_messsystem'] += ', ' + item.messsystem;
                    } else {
                        base[jahr]['diesel_messsystem'] = item.messsystem;
                    }
                }
                if (item.kalibrierung) {
                    if (base[jahr]['diesel_kalibrierung']) {
                        base[jahr]['diesel_kalibrierung'] += ', ' + item.kalibrierung;
                    } else {
                        base[jahr]['diesel_kalibrierung'] = item.kalibrierung;
                    }
                }
                if (!base[jahr].diesel_datenqualitaet) {
                    base[jahr].diesel_datenqualitaet = [];
                }
                base[jahr].diesel_verbrauch = (base[jahr].diesel_verbrauch || 0) + verbrauch;
                base[jahr].diesel_kosten = (base[jahr].diesel_kosten || 0) + kosten;
                base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten;
                // CO2
                base[jahr].co2_fussabdruck_diesel_menge = (base[jahr].co2_fussabdruck_diesel_menge || 0) + verbrauch;
                base[jahr].co2_fussabdruck_diesel_einheit = 'Liter';
                base[jahr].diesel_datenqualitaet.push({
                    wert: +(verbrauch || 0), datenherkunft: +(item.datenherkunft || 0), bewertung: 1
                });
                // Kennzahl
                let faktor_um_quelle;
                const faktor_um = getUmrechungsFaktor(data, '', jahr, 'dieselkraftstoffe', (data: any) => faktor_um_quelle = data.quelle_dieselkraftstoffe);
                setKennzahlKraftstoffe(standort, data, 'diesel_liter', 'verbrauch', item, 'Diesel', 'Liter');
                setKennzahlKraftstoffe(standort, data, 'diesel_kwh', 'verbrauch', item, 'Diesel', 'kWh', 'Liter', faktor_um, faktor_um_quelle);
                setKennzahlKraftstoffe(standort, data, 'diesel_kosten', 'kosten', item, 'Diesel', '€');
                const faktor_co2 = getCO2Aequivalent(data, jahr, 'diesel', false);
                if (faktor_co2) {
                    setKennzahlKraftstoffe(standort, data, 'diesel_co2', 'verbrauch', item, 'Diesel', 'tCO₂Äq', 'Liter', faktor_um, faktor_um_quelle, faktor_co2.wert, faktor_co2.quelle);
                }
            } else if (energietraeger === 'LPG [Liter]') {
                if (item.messsystem) {
                    if (base[jahr]['lpg_messsystem']) {
                        base[jahr]['lpg_messsystem'] += ', ' + item.messsystem;
                    } else {
                        base[jahr]['lpg_messsystem'] = item.messsystem;
                    }
                }
                if (item.kalibrierung) {
                    if (base[jahr]['lpg_kalibrierung']) {
                        base[jahr]['lpg_kalibrierung'] += ', ' + item.kalibrierung;
                    } else {
                        base[jahr]['lpg_kalibrierung'] = item.kalibrierung;
                    }
                }
                if (!base[jahr].lpg_datenqualitaet) {
                    base[jahr].lpg_datenqualitaet = [];
                }
                base[jahr].lpg_verbrauch = (base[jahr].lpg_verbrauch || 0) + verbrauch;
                base[jahr].lpg_kosten = (base[jahr].lpg_kosten || 0) + kosten;
                base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten;
                // CO2
                base[jahr].co2_fussabdruck_lpg_menge = (base[jahr].co2_fussabdruck_lpg_menge || 0) + verbrauch;
                base[jahr].co2_fussabdruck_lpg_einheit = 'Liter';
                base[jahr].lpg_datenqualitaet.push({
                    wert: +(verbrauch || 0), datenherkunft: +(item.datenherkunft || 0), bewertung: 1
                });
                // Kennzahl
                let faktor_um_quelle;
                const faktor_um = getUmrechungsFaktor(data, '', jahr, 'fluessiggas_l', (data: any) => faktor_um_quelle = data.quelle_fluessiggas_l);
                setKennzahlKraftstoffe(standort, data, 'lpg_liter', 'verbrauch', item, 'LPG', 'Liter');
                setKennzahlKraftstoffe(standort, data, 'lpg_kwh', 'verbrauch', item, 'LPG', 'kWh', 'Liter', faktor_um, faktor_um_quelle);
                setKennzahlKraftstoffe(standort, data, 'lpg_kosten', 'kosten', item, 'LPG', '€');
                const faktor_co2 = getCO2Aequivalent(data, jahr, 'lpg', false);
                if (faktor_co2) {
                    setKennzahlKraftstoffe(standort, data, 'lpg_co2', 'verbrauch', item, 'LPG', 'tCO₂Äq', 'Liter', faktor_um, faktor_um_quelle, faktor_co2.wert, faktor_co2.quelle);
                }
            } else if (energietraeger === 'Wasserstoff [kWh]') {
                if (item.messsystem) {
                    if (base[jahr]['wasserstoff_messsystem']) {
                        base[jahr]['wasserstoff_messsystem'] += ', ' + item.messsystem;
                    } else {
                        base[jahr]['wasserstoff_messsystem'] = item.messsystem;
                    }
                }
                if (item.kalibrierung) {
                    if (base[jahr]['wasserstoff_kalibrierung']) {
                        base[jahr]['wasserstoff_kalibrierung'] += ', ' + item.kalibrierung;
                    } else {
                        base[jahr]['wasserstoff_kalibrierung'] = item.kalibrierung;
                    }
                }
                if (!base[jahr].wasserstoff_kwh_datenqualitaet) {
                    base[jahr].wasserstoff_kwh_datenqualitaet = [];
                }
                base[jahr].wasserstoff_verbrauch = (base[jahr].wasserstoff_verbrauch || 0) + verbrauch;
                base[jahr].wasserstoff_kosten = (base[jahr].wasserstoff_kosten || 0) + kosten;
                base[jahr].wasserstoff_kwh_verbrauch = (base[jahr].wasserstoff_kwh_verbrauch || 0) + verbrauch;
                base[jahr].wasserstoff_kwh_kosten = (base[jahr].wasserstoff_kwh_kosten || 0) + kosten;
                base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten;
                // CO2
                base[jahr].co2_fussabdruck_wasserstoff_kwh_menge = (base[jahr].co2_fussabdruck_wasserstoff_kwh_menge || 0) + verbrauch;
                base[jahr].co2_fussabdruck_wasserstoff_kwh_einheit = 'kWh';
                base[jahr].wasserstoff_kwh_datenqualitaet.push({
                    wert: +(verbrauch || 0), datenherkunft: +(item.datenherkunft || 0), bewertung: 1
                });
                // Kennzahl
                setKennzahlKraftstoffe(standort, data, 'wasserstoff_kwh', 'verbrauch', item, 'Wasserstoff', 'kWh');
                setKennzahlKraftstoffe(standort, data, 'wasserstoff_kosten', 'kosten', item, 'Wasserstoff', '€');
                const faktor_co2 = getCO2Aequivalent(data, jahr, 'wasserstoff', false);
                if (faktor_co2) {
                    setKennzahlKraftstoffe(standort, data, 'wasserstoff_co2', 'verbrauch', item, 'Wasserstoff', 'tCO₂Äq', 'kWh', undefined, undefined, faktor_co2.wert, faktor_co2.quelle);
                }
            } else if (energietraeger === 'Wasserstoff [kg]') {
                if (item.messsystem) {
                    if (base[jahr]['wasserstoff_messsystem']) {
                        base[jahr]['wasserstoff_messsystem'] += ', ' + item.messsystem;
                    } else {
                        base[jahr]['wasserstoff_messsystem'] = item.messsystem;
                    }
                }
                if (item.kalibrierung) {
                    if (base[jahr]['wasserstoff_kalibrierung']) {
                        base[jahr]['wasserstoff_kalibrierung'] += ', ' + item.kalibrierung;
                    } else {
                        base[jahr]['wasserstoff_kalibrierung'] = item.kalibrierung;
                    }
                }
                if (!base[jahr].wasserstoff_kg_datenqualitaet) {
                    base[jahr].wasserstoff_kg_datenqualitaet = [];
                }
                const faktor_kg_kwh = getUmrechungsFaktor(data, '', jahr, 'wasserstoff');
                base[jahr].wasserstoff_verbrauch = (base[jahr].wasserstoff_verbrauch || 0) + verbrauch * faktor_kg_kwh;
                base[jahr].wasserstoff_kosten = (base[jahr].wasserstoff_kosten || 0) + kosten;
                base[jahr].wasserstoff_kg_verbrauch = (base[jahr].wasserstoff_kg_verbrauch || 0) + verbrauch * faktor_kg_kwh;
                base[jahr].wasserstoff_kg_kosten = (base[jahr].wasserstoff_kg_kosten || 0) + kosten;
                base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten;
                // CO2
                base[jahr].co2_fussabdruck_wasserstoff_kg_menge = (base[jahr].co2_fussabdruck_wasserstoff_kg_menge || 0) + verbrauch;
                base[jahr].co2_fussabdruck_wasserstoff_kg_einheit = 'kg';
                base[jahr].wasserstoff_kg_datenqualitaet.push({
                    wert: +(verbrauch || 0), datenherkunft: +(item.datenherkunft || 0), bewertung: 1
                });
                // Kennzahl
                let faktor_um_quelle;
                const faktor_um = getUmrechungsFaktor(data, '', jahr, 'wasserstoff', (data: any) => faktor_um_quelle = data.quelle_wasserstoff);
                setKennzahlKraftstoffe(standort, data, 'wasserstoff_kwh', 'verbrauch', item, 'Wasserstoff', 'kWh', 'kg', faktor_um, faktor_um_quelle);
                setKennzahlKraftstoffe(standort, data, 'wasserstoff_kg', 'verbrauch', item, 'Wasserstoff', 'kg');
                setKennzahlKraftstoffe(standort, data, 'wasserstoff_kosten', 'kosten', item, 'Wasserstoff', '€');
                const faktor_co2 = getCO2Aequivalent(data, jahr, 'wasserstoff', false);
                if (faktor_co2) {
                    setKennzahlKraftstoffe(standort, data, 'wasserstoff_co2', 'verbrauch', item, 'Wasserstoff', 'tCO₂Äq', 'kg', faktor_um, faktor_um_quelle, faktor_co2.wert, faktor_co2.quelle);
                }
            } else if (energietraeger === 'Erdgas [kWh]') {
                if (item.messsystem) {
                    if (base[jahr]['erdgas_messsystem']) {
                        base[jahr]['erdgas_messsystem'] += ', ' + item.messsystem;
                    } else {
                        base[jahr]['erdgas_messsystem'] = item.messsystem;
                    }
                }
                if (item.kalibrierung) {
                    if (base[jahr]['erdgas_kalibrierung']) {
                        base[jahr]['erdgas_kalibrierung'] += ', ' + item.kalibrierung;
                    } else {
                        base[jahr]['erdgas_kalibrierung'] = item.kalibrierung;
                    }
                }
                if (!base[jahr].erdgas_kwh_datenqualitaet) {
                    base[jahr].erdgas_kwh_datenqualitaet = [];
                }
                base[jahr].erdgas_kraftstoff_verbrauch = (base[jahr].erdgas_kraftstoff_verbrauch || 0) + verbrauch;
                base[jahr].erdgas_kraftstoff_kosten = (base[jahr].erdgas_kraftstoff_kosten || 0) + kosten;
                base[jahr].erdgas_kwh_verbrauch = (base[jahr].erdgas_kwh_verbrauch || 0) + verbrauch;
                base[jahr].erdgas_kwh_kosten = (base[jahr].erdgas_kwh_kosten || 0) + kosten;
                base[jahr].erdgas_kosten = (base[jahr].erdgas_kosten || 0) + kosten;
                base[jahr].erdgas_verbrauch = (base[jahr].erdgas_verbrauch || 0) + verbrauch;
                base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten;
                // CO2
                base[jahr].co2_fussabdruck_erdgas_menge = (base[jahr].co2_fussabdruck_erdgas_menge || 0) + verbrauch;
                base[jahr].co2_fussabdruck_erdgas_einheit = 'kWh';
                base[jahr].erdgas_kwh_datenqualitaet.push({
                    wert: +(verbrauch || 0), datenherkunft: +(item.datenherkunft || 0), bewertung: 1
                });
                // Kennzahl
                setKennzahlKraftstoffe(standort, data, 'erdgas_kwh', 'verbrauch', item, 'Erdgas', 'kWh');
                setKennzahlKraftstoffe(standort, data, 'erdgas_kosten', 'kosten', item, 'Erdgas', '€');
                const faktor_co2 = getCO2Aequivalent(data, jahr, 'erdgas', false);
                if (faktor_co2) {
                    setKennzahlKraftstoffe(standort, data, 'erdgas_co2', 'verbrauch', item, 'Erdgas', 'tCO₂Äq', 'kWh', undefined, undefined, faktor_co2.wert, faktor_co2.quelle);
                }
            } else if (energietraeger === 'Erdgas - CNG [kg]') {
                if (item.messsystem) {
                    if (base[jahr]['erdgas_messsystem']) {
                        base[jahr]['erdgas_messsystem'] += ', ' + item.messsystem;
                    } else {
                        base[jahr]['erdgas_messsystem'] = item.messsystem;
                    }
                }
                if (item.kalibrierung) {
                    if (base[jahr]['erdgas_kalibrierung']) {
                        base[jahr]['erdgas_kalibrierung'] += ', ' + item.kalibrierung;
                    } else {
                        base[jahr]['erdgas_kalibrierung'] = item.kalibrierung;
                    }
                }
                if (!base[jahr].erdgas_cng_kg_datenqualitaet) {
                    base[jahr].erdgas_cng_kg_datenqualitaet = [];
                }
                const faktor_kg_kwh = getUmrechungsFaktor(data, '', jahr, 'erdgas_cng_kg');
                base[jahr].erdgas_kraftstoff_verbrauch = (base[jahr].erdgas_kraftstoff_verbrauch || 0) + verbrauch * faktor_kg_kwh;
                base[jahr].erdgas_kraftstoff_kosten = (base[jahr].erdgas_kraftstoff_kosten || 0) + kosten;
                base[jahr].erdgas_cng_kg_verbrauch = (base[jahr].erdgas_cng_kg_verbrauch || 0) + verbrauch * faktor_kg_kwh;
                base[jahr].erdgas_cng_kg_kosten = (base[jahr].erdgas_cng_kg_kosten || 0) + kosten;
                base[jahr].erdgas_kosten = (base[jahr].erdgas_kosten || 0) + kosten;
                base[jahr].erdgas_verbrauch = (base[jahr].erdgas_verbrauch || 0) + verbrauch * faktor_kg_kwh;
                base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten;
                // CO2
                base[jahr].co2_fussabdruck_erdgas_cng_kg_menge = (base[jahr].co2_fussabdruck_erdgas_cng_kg_menge || 0) + verbrauch;
                base[jahr].co2_fussabdruck_erdgas_cng_kg_einheit = 'kg';
                base[jahr].erdgas_cng_kg_datenqualitaet.push({
                    wert: +(verbrauch || 0), datenherkunft: +(item.datenherkunft || 0), bewertung: 1
                });
                // Kennzahl
                let faktor_um_quelle;
                const faktor_um = getUmrechungsFaktor(data, '', jahr, 'erdgas_cng_kg', (data: any) => faktor_um_quelle = data.quelle_erdgas_cng_kg);
                setKennzahlKraftstoffe(standort, data, 'erdgas_kwh', 'verbrauch', item, 'Erdgas', 'kWh', 'kg', faktor_um, faktor_um_quelle);
                setKennzahlKraftstoffe(standort, data, 'erdgas_kosten', 'kosten', item, 'Erdgas', '€');
                setKennzahlKraftstoffe(standort, data, 'erdgas_cng_kg', 'verbrauch', item, 'Erdgas - CNG', 'kg');
                const faktor_co2 = getCO2Aequivalent(data, jahr, 'erdgas', false);
                if (faktor_co2) {
                    setKennzahlKraftstoffe(standort, data, 'erdgas_cng_co2', 'verbrauch', item, 'Erdgas - CNG', 'tCO₂Äq', 'kg', faktor_um, faktor_um_quelle, faktor_co2.wert, faktor_co2.quelle);
                }
            } else if (energietraeger === 'Erdgas - LNG [kg]') {
                if (item.messsystem) {
                    if (base[jahr]['erdgas_messsystem']) {
                        base[jahr]['erdgas_messsystem'] += ', ' + item.messsystem;
                    } else {
                        base[jahr]['erdgas_messsystem'] = item.messsystem;
                    }
                }
                if (item.kalibrierung) {
                    if (base[jahr]['erdgas_kalibrierung']) {
                        base[jahr]['erdgas_kalibrierung'] += ', ' + item.kalibrierung;
                    } else {
                        base[jahr]['erdgas_kalibrierung'] = item.kalibrierung;
                    }
                }
                if (!base[jahr].erdgas_lng_kg_datenqualitaet) {
                    base[jahr].erdgas_lng_kg_datenqualitaet = [];
                }
                const faktor_kg_kwh = getUmrechungsFaktor(data, '', jahr, 'erdgas_lng_kg');
                base[jahr].erdgas_kraftstoff_verbrauch = (base[jahr].erdgas_kraftstoff_verbrauch || 0) + verbrauch * faktor_kg_kwh;
                base[jahr].erdgas_kraftstoff_kosten = (base[jahr].erdgas_kraftstoff_kosten || 0) + kosten;
                base[jahr].erdgas_lng_kg_verbrauch = (base[jahr].erdgas_lng_kg_verbrauch || 0) + verbrauch * faktor_kg_kwh;
                base[jahr].erdgas_lng_kg_kosten = (base[jahr].erdgas_lng_kg_kosten || 0) + kosten;
                base[jahr].erdgas_kosten = (base[jahr].erdgas_kosten || 0) + kosten;
                base[jahr].erdgas_verbrauch = (base[jahr].erdgas_verbrauch || 0) + verbrauch * faktor_kg_kwh;
                base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten;
                // CO2
                base[jahr].co2_fussabdruck_erdgas_lng_kg_menge = (base[jahr].co2_fussabdruck_erdgas_lng_kg_menge || 0) + verbrauch;
                base[jahr].co2_fussabdruck_erdgas_lng_kg_einheit = 'kg';
                base[jahr].erdgas_lng_kg_datenqualitaet.push({
                    wert: +(verbrauch || 0), datenherkunft: +(item.datenherkunft || 0), bewertung: 1
                });
                // Kennzahl
                let faktor_um_quelle;
                const faktor_um = getUmrechungsFaktor(data, '', jahr, 'erdgas_lng_kg', (data: any) => faktor_um_quelle = data.quelle_erdgas_lng_kg);
                setKennzahlKraftstoffe(standort, data, 'erdgas_kwh', 'verbrauch', item, 'Erdgas', 'kWh', 'kg', faktor_um, faktor_um_quelle);
                setKennzahlKraftstoffe(standort, data, 'erdgas_kosten', 'kosten', item, 'Erdgas', '€');
                setKennzahlKraftstoffe(standort, data, 'erdgas_lng_kg', 'verbrauch', item, 'Erdgas - LNG', 'kg');
                const faktor_co2 = getCO2Aequivalent(data, jahr, 'erdgas', false);
                if (faktor_co2) {
                    setKennzahlKraftstoffe(standort, data, 'erdgas_lng_co2', 'verbrauch', item, 'Erdgas - LNG', 'tCO₂Äq', 'kg', faktor_um, faktor_um_quelle, faktor_co2.wert, faktor_co2.quelle);
                }
            } else if (energietraeger === 'Ladestrom [kWh]') {
                if (item.messsystem) {
                    if (base[jahr]['ladestrom_messsystem']) {
                        base[jahr]['ladestrom_messsystem'] += ', ' + item.messsystem;
                    } else {
                        base[jahr]['ladestrom_messsystem'] = item.messsystem;
                    }
                }
                if (item.kalibrierung) {
                    if (base[jahr]['ladestrom_kalibrierung']) {
                        base[jahr]['ladestrom_kalibrierung'] += ', ' + item.kalibrierung;
                    } else {
                        base[jahr]['ladestrom_kalibrierung'] = item.kalibrierung;
                    }
                }
                if (!base[jahr].ladestrom_datenqualitaet) {
                    base[jahr].ladestrom_datenqualitaet = [];
                }
                let co2_faktor = (item.co2_emissionen || item.co2_emissionen === 0) ? item.co2_emissionen / 1000000 : null;
                let co2_quelle = 'Emissionsfaktor lt. Versorgerrechnung / Eingabe durch Nutzer';
                if (!co2_faktor) {
                    const faktor_object = getEmissionsFaktor(data, '', jahr, 'strom_mix');
                    co2_faktor = base[jahr].faktor_strom_co2_calc || faktor_object.wert;
                    co2_quelle = faktor_object.quelle;
                }
                const co2_emissionen = verbrauch * co2_faktor;
                const strom_bundesdurchschnitt = typeof item.verbrauch === 'number' ? verbrauch : null;
                base[jahr].ladestrom_co2 = (base[jahr].ladestrom_co2 || 0) + co2_emissionen;
                base[jahr].ladestrom_verbrauch = (base[jahr].ladestrom_verbrauch || 0) + verbrauch;
                base[jahr].ladestrom_kosten = (base[jahr].ladestrom_kosten || 0) + kosten;
                base[jahr].kosten_total = (base[jahr].kosten_total || 0) + kosten;
                base[jahr].strom_bundesdurchschnitt = strom_bundesdurchschnitt + (base[jahr].strom_bundesdurchschnitt || 0);

                // CO2
                const co2_bundesdurchschnitt = typeof item.verbrauch === 'number' ? verbrauch * (getCO2Aequivalent(data, jahr, 'strom', false) || {}).wert : null;
                base[jahr].co2_fussabdruck_ladestrom_co2 = (base[jahr].co2_fussabdruck_ladestrom_co2 || 0) + co2_emissionen;
                base[jahr].co2_fussabdruck_ladestrom_menge = (base[jahr].co2_fussabdruck_ladestrom_menge || 0) + verbrauch;
                base[jahr].co2_fussabdruck_ladestrom_einheit = 'kWh';
                base[jahr].co2_fussabdruck_ladestrom_quelle = co2_quelle;
                base[jahr].ladestrom_datenqualitaet.push({
                    wert: +(verbrauch || 0), datenherkunft: +(item.datenherkunft || 0), bewertung: 1
                });
                base[jahr].co2_strom_bundesdurchschnitt = co2_bundesdurchschnitt + (base[jahr].co2_strom_bundesdurchschnitt || 0);

                // Kennzahl
                setKennzahlKraftstoffe(standort, data, 'ladestrom_kwh', 'verbrauch', item, 'Ladestrom', 'kWh');
                setKennzahlKraftstoffe(standort, data, 'ladestrom_kosten', 'kosten', item, 'Ladestrom', '€');
                let faktor_co2 = getCO2Aequivalent(data, jahr, 'strom', false);

                if (standort) {
                    const kenn_bundesdurchschnitt: Kennzahl = getKennzahl('s2_strom_bundesdurchschnitt', 'verbrauch', jahr, standort ? standort.tid : 'ALL', data);
                    const kenn_bundesdurchschnitt_co2: Kennzahl = getKennzahl('s2_strom_bundesdurchschnitt', 'co2', jahr, standort ? standort.tid : 'ALL', data);
                    if (!kenn_bundesdurchschnitt.isInitialized()) {
                        kenn_bundesdurchschnitt
                            .setEinheit('kWh')
                            .setBereich(Kennzahl.BEREICH_SCOPE2)
                            .setType(Kennzahl.TYPE_SUMME)
                            .setName('Verbrauch Strom Bundesdurchschnitt');
                    }
                    if (!kenn_bundesdurchschnitt_co2.isInitialized()) {
                        kenn_bundesdurchschnitt_co2
                            .setEinheit('tCO₂Äq')
                            .setBereich(Kennzahl.BEREICH_SCOPE2)
                            .setType(Kennzahl.TYPE_SUMME)
                            .setName('CO₂-Emission Strom Bundesdurchschnitt');
                    }
                    const kenn_item_bundesdurchschnitt: Kennzahl = kenn_bundesdurchschnitt.addValue(verbrauch, item.tid);
                    const zaehler = item.zaehler_tid_orig ? item.zaehler_tid : null;
                    kenn_item_bundesdurchschnitt
                        .setType(Kennzahl.TYPE_EINGABE)
                        .setInfo(zaehler ? `Zähler: ${zaehler}` : undefined)
                        .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                    if (co2_faktor) {
                        const kenn_item_bundesdurchschnitt_co2: Kennzahl = kenn_bundesdurchschnitt_co2.addValue(co2_bundesdurchschnitt, item.tid);
                        kenn_item_bundesdurchschnitt_co2
                            .setType(Kennzahl.TYPE_BERECHNUNG)
                            .addItem(kenn_item_bundesdurchschnitt)
                            .addFaktor(faktor_co2.wert, KennzahlFaktor.TYPE_CO2, faktor_co2.quelle, 'CO₂-Faktor')
                            .setDatum(item.abrechnungszeitraum_von, item.abrechnungszeitraum_bis);
                        faktor_co2 = {
                            wert: co2_faktor,
                            quelle: 'Nutzereingabe'
                        };
                    }
                }
                if (faktor_co2) {
                    setKennzahlKraftstoffe(standort, data, 'ladestrom_co2', 'verbrauch', item, 'Ladestrom', 'tCO₂Äq', 'kWh', undefined, undefined, faktor_co2.wert, faktor_co2.quelle);
                }
            }
        });

    setKennzahlPreisen(standort, data, base);
}

function setKennzahlKraftstoffe(standort: any, data: any, key: string, field: string, item: any, energietraeger: string, einheit: string,
    einheitOrig?: string, faktor_um?: number, faktor_um_quelle?: string, faktor_co2?: number, faktor_co2_quelle?: string): Kennzahl {
    let kennItem: Kennzahl;
    if (standort) {
        const name = faktor_co2 ? 'CO2-Emissionen Kraftstoffe' : `${parseKey(field)} Kraftstoffe`;
        const kennName = `${name} ${energietraeger}`;
        const gesamtName = `${name} Gesamt`;
        let gesamtKey: string;
        if (einheit === 'kWh') {
            gesamtKey = `kraftstoffe_gesamt`;
        } else if (einheit === '€') {
            gesamtKey = `kraftstoffe_gesamt_kosten`;
        } else if (faktor_co2) {
            gesamtKey = `kraftstoffe_gesamt_co2`;
        }
        // Verbrauch, CO2, Kosten
        kennItem = setKennzahlObj({
            standort_tid: (standort || {}).tid,
            data,
            kennName,
            bereich: Kennzahl.BEREICH_KRAFTSTOFFE,
            key,
            field,
            item,
            einheit,
            einheitOrig,
            gesamtKey,
            gesamtName,
            faktor_um,
            faktor_um_einheit: faktor_um && einheitOrig ? `kWh/${einheitOrig}` : undefined,
            faktor_um_quelle,
            faktor_co2,
            faktor_co2_quelle
        });
    }
    return kennItem;
}

function setKennzahlPreisen(standort: any, data: any, base: any) {
    if (standort) {
        const config: any = {
            diesel: { name: 'Diesel', verbrauch: 'diesel_verbrauch', verbrauch_einheit: 'l', kosten: 'diesel_kosten', einheit: '€/l' },
            benzin: { name: 'Benzin', verbrauch: 'benzin_verbrauch', verbrauch_einheit: 'l', kosten: 'benzin_kosten', einheit: '€/l' },
            lpg: { name: 'LPG', verbrauch: 'lpg_verbrauch', verbrauch_einheit: 'l', kosten: 'lpg_kosten', einheit: '€/l' },
            biodiesel: { name: 'Biodiesel', verbrauch: 'biodiesel_verbrauch', verbrauch_einheit: 'kWh', kosten: 'biodiesel_kosten', einheit: '€/kWh', faktor: 'biodiesel' },
            bioethanol: { name: 'Bioethanol', verbrauch: 'bioethanol_verbrauch', verbrauch_einheit: 'kWh', kosten: 'bioethanol_kosten', einheit: '€/kWh', faktor: 'bioethanol' },
            wasserstoff: { name: 'Wasserstoff', verbrauch: 'wasserstoff_verbrauch', verbrauch_einheit: 'kWh', kosten: 'wasserstoff_kosten', einheit: '€/kWh' },
            erdgas: { name: 'Erdgas', verbrauch: 'erdgas_verbrauch', verbrauch_einheit: 'kWh', kosten: 'erdgas_kosten', einheit: '€/kWh' },
            ladestrom: { name: 'Ladestrom', verbrauch: 'ladestrom_verbrauch', verbrauch_einheit: 'kWh', kosten: 'ladestrom_kosten', einheit: '€/kWh' }
        };
        Object.keys(base).forEach((k: string) => {
            if (parseInt(k) === +k) {
                const jahr = +k;
                Object.keys(config).forEach((eKey: string) => {
                    const faktor = config[eKey].faktor ? getUmrechungsFaktor(data, '', jahr, config[eKey].faktor) || 1 : 1;
                    const verbrauch = base[jahr][config[eKey].verbrauch] * faktor;
                    const kosten = base[jahr][config[eKey].kosten];
                    // console.log(jahr, eKey, verbrauch, kosten, base[jahr]);
                    if (verbrauch > 0 && kosten > 0) {
                        const preis = kosten / verbrauch;
                        const item = { preis, jahr };
                        const berechnung = `${preis} ${config[eKey].einheit} = ${kosten} € : ${verbrauch} ${config[eKey].verbrauch_einheit}`;
                        const kenn: Kennzahl = setKennzahlKraftstoffe(standort, data, `${eKey}_preis`, 'preis', item, config[eKey].name, config[eKey].einheit);
                        kenn.setType(Kennzahl.TYPE_BERECHNUNG);
                        (kenn.getItems() || []).forEach((kenn_item: Kennzahl) => {
                            kenn_item
                                .setType(Kennzahl.TYPE_BERECHNUNG)
                                .setInfo(berechnung)
                                .setFormel('preis');
                        });
                    }
                });
            }
        });
    }
}

